import mediator from "@tvg/mediator";
import { EventData, EventProps, MediatorEventType } from "./types";
import { track } from "../../amplitude";
import { BaseEventProps } from "../../types";
import { EVENT_NAME } from "./constants";

export default () => {
  mediator.base.subscribe(MediatorEventType.CLICK, (data: EventData) =>
    track<EventProps>(EVENT_NAME.NAVIGATED, {
      [BaseEventProps.EVENT_CATEGORY]: "Navigation",
      [BaseEventProps.LINK_TEXT]: data.payload.linkName,
      [BaseEventProps.MODULE]: "Quick Links",
      [BaseEventProps.LINK_URL]: data.payload.fullURL
    })
  );
};
